import React, { useState, useEffect } from "react";

import {
  Typography,
  Input,
  Form,
  Button,
  Space,
  Skeleton,
  Collapse,
  message,
  notification,
  Drawer,
  Image,
  Select,
} from "antd";

import {
  EnvironmentOutlined,
  CaretRightOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { FaLocationDot } from "react-icons/fa6";
import { IoStorefrontSharp } from "react-icons/io5";

import DynamicCategoryTabs from "../components/categories-component";
import ItemDetails from "./item-details";
import ReviewOrder from "./review-order";
import PabiliMap from "./pabili-map";
import merchatOtherLogo from "../assets/location.png";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMercantsInArea,
  fetchMerchantCategories,
  clearMerchantList,
  clearCategories,
  clearOrderItems,
  clearMerchantMenus,
  setOrderFormData,
  setSelectedItem,
  setToggleReviewOrder,
  setFinalCustomerDetails,
  setToggleItemDetails,
  setTogglePabiliMap,
  setPabiliDetails,
} from "../redux/feature/order";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import RedirectModal from "../components/redirect.component";
// import { useSearchParams } from "react-router-dom";

const { Title, Text } = Typography;
const { Panel } = Collapse;
const { TextArea, Search } = Input;

const schema = yup
  .object({
    fullName: yup.string().required("Full name is required"),
    contactNumber: yup
      .string()
      .required("Contact number is required")
      .matches(/^[0-9]+$/, "Contact number must contain only digits")
      .length(11, "Contact number must be exactly 11 digits"),
    province: yup.string().required("Province is required"),
    city: yup.string().required("City is required"),
    address: yup.string().required("Address is required"),
    merchant: yup.string().required("Merchant is required"),
    customerLatitude: yup.string().required("Customer Latitude is required"),
    customerLongitude: yup.string().required("Customer Longitude is required"),
  })
  .required();

// const getUniqueOptions = (options, key) => {
//   const seen = new Set();
//   return options
//     .filter((item) => {
//       const keyValue = item[key];
//       return seen.has(keyValue) ? false : seen.add(keyValue);
//     })
//     .map((item) => ({
//       value: item["prov_code"],
//       label: item["name"],
//     }));
// };

const OrderFormPage = () => {
  const dispatch = useDispatch();
  // const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [api] = notification.useNotification();
  const [messageApi, contextHolder] = message.useMessage();
  const [bottomDrawer, setBottomDrawer] = useState(false);
  // const [cities, setCities] = useState([]);
  const [formCompleted, setFormCompleted] = useState(false);
  const [activeKey, setActiveKey] = useState(["1"]);
  const [coordinates, setCoordinates] = useState({});
  const [locationLoading, setLocationLoading] = useState(false);
  const [note, setNote] = useState("");
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedMerchantValue, setSelectedMerchantValue] = useState(null);
  const [modal, setModal] = useState(false);
  const [greeting, setGreeting] = useState("");
  const [searchPattern, setSearchPattern] = useState([]);
  const [inputValue, setInputValue] = useState("");

  // const fullName = searchParams.get("fullName");
  // const contactNumber = searchParams.get("contactNumber");

  const showDrawer = () => {
    setBottomDrawer(true);
  };

  // const handleDropdownVisibility = (open) => {
  //   setIsDropdownOpen(open);
  //   if (open) {
  //     // Freeze scrolling
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     // Enable scrolling
  //     document.body.style.overflow = "auto";
  //   }
  // };

  const {
    loading,
    merchantsInArea,
    merchantCategories,
    categoryLoading,
    orderFormData,
    orderItems,
    toggleReviewOrder,
    pabiliDetails,
    menuLoading,
  } = useSelector((state) => state.order);

  const initialValues = {
    fullName: "",
    contactNumber: "",
    province: "",
    city: "",
    address: "",
    merchant: "",
    customerLatitude: "",
    customerLongitude: "",
  };

  // const uniqueOptions = getUniqueOptions(phil.provinces, "prov_code");

  const {
    control,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });

  const provinceContainer = watch("province");
  const address = watch("address");
  const cityContainer = watch("city");
  const selectedMerchant = watch("merchant");

  const isPabiliDetailsValid =
    Object.keys(pabiliDetails).length !== 0 && selectedMerchant === 1;

  // const openNotificationWithIcon = (type, message, description) => {
  //   api[type]({
  //     message,
  //     description,
  //   });
  // };

  useEffect(() => {
    const currentHour = new Date().getHours();

    if (currentHour < 12) {
      setGreeting("Good Morning!");
    } else if (currentHour >= 12 && currentHour < 18) {
      setGreeting("Good Afternoon!");
    } else {
      setGreeting("Good Evening!");
    }
  }, []);

  useEffect(() => {
    if (orderFormData) {
      // Set the form values from Redux when the page loads
      setValue("fullName", orderFormData.fullName || "");
      setValue("contactNumber", orderFormData.contactNumber || "");
      setValue("province", orderFormData.province || "");
      setValue("city", orderFormData.city || "");
      setValue("address", orderFormData.address || "");
      setValue("merchant", orderFormData.merchant || "");
    }
  }, [orderFormData, setValue]);

  // useEffect(() => {
  //   if (provinceContainer) {
  //     setValue("city", "");
  //     setValue("merchant", "");
  //     dispatch(clearMerchantList());
  //     dispatch(clearCategories());
  //     dispatch(clearOrderItems());
  //     dispatch(clearMerchantMenus());

  //     const filteredCities = phil.getCityMunByProvince(provinceContainer);

  //     const structuredCities = filteredCities.map((a) => {
  //       return { value: a.mun_code, label: a.name };
  //     });

  //     setCities(structuredCities);
  //   }
  // }, [provinceContainer, dispatch, setValue]);

  useEffect(() => {
    if (cityContainer && provinceContainer) {
      // const realProvince = phil.provinces.filter(
      //   (province) => province.prov_code === provinceContainer
      // )[0].name;
      // const realCity = phil.city_mun.filter(
      //   (city) => city.mun_code === cityContainer
      // )[0].name;

      setSelectedMerchantValue(null);
      setValue("merchant", "");
      dispatch(clearMerchantList());
      dispatch(clearCategories());
      dispatch(clearOrderItems());
      dispatch(clearMerchantMenus());
      dispatch(
        fetchMercantsInArea({
          city: cityContainer,
          province: provinceContainer,
        }),
      );
    }
  }, [cityContainer, provinceContainer, dispatch, setValue]);

  useEffect(() => {
    if (selectedMerchant) {
      if (selectedMerchant === 1) {
        dispatch(setFinalCustomerDetails({}));
        // dispatch(setTogglePabiliMap(true));

        const fullName = watch("fullName");
        const contactNumber = watch("contactNumber");

        navigate(
          `/pabili-padala-checkout?name=${fullName}&contactNumber=${contactNumber}`,
        );
      } else {
        dispatch(setFinalCustomerDetails({}));
        setNote("");
        dispatch(setPabiliDetails({}));
        dispatch(clearOrderItems());
        dispatch(clearCategories());
        dispatch(clearMerchantMenus());
        dispatch(fetchMerchantCategories({ merchantId: selectedMerchant }));
      }
    }
  }, [selectedMerchant, dispatch]);

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const successMessage = (isUpdate) => {
    messageApi.open({
      type: "success",
      content: isUpdate ? "Item Updated" : "Item added to cart!",
    });
  };

  const onSubmit = (values) => {
    // const province = phil.provinces.filter(
    //   (province) => province.prov_code === values.province
    // )[0];
    // const city = phil.city_mun.filter(
    //   (city) => city.mun_code === values.city
    // )[0]?.name;

    const customerDetails = {
      fullName: values.fullName,
      contactNumber: values.contactNumber,
      address: values.address,
      province: values.province,
      city: values.city,
      selectedMerchant,
      coordinates,
      pabiliDetails: selectedMerchant === 1 ? { ...pabiliDetails, note } : null,
    };

    dispatch(setFinalCustomerDetails(customerDetails));
    dispatch(setToggleReviewOrder(true));
  };

  const handleFieldChange = (name, value) => {
    const completed = Object.entries(watch())
      .filter(([key]) => key !== "merchant")
      .every(([_, value]) => value !== "");

    setFormCompleted(completed);

    const formData = watch();

    dispatch(setOrderFormData(formData));
  };

  const handleCollapseChange = (key) => {
    if (formCompleted) {
      setActiveKey(key);
    }
  };

  const onClickProduct = async (selectedProduct, variantSize = "[]") => {
    const parsedVariants = JSON.parse(variantSize).filter(
      (item) => item.isActive,
    );

    let variant = {};
    let menuAddOns = selectedProduct.add_ons || [];

    if (parsedVariants?.length !== 0) {
      let choicesData = parsedVariants.map((i) => {
        const markupValue =
          parseFloat(i.price) +
          (parseFloat(i.price) *
            parseFloat(selectedProduct.mark_up_percentage)) /
            parseFloat(100);

        return {
          choice_name: i.variant,
          choice_price: Math.ceil(markupValue),
          variantID: i.variantID,
          choice_id: i.variantID,
        };
      });

      variant.group_name = "Variants";
      variant.group_type = "preference";
      variant.group_max_selection = 1;
      variant.group_isRequired = 1;
      variant.choices = choicesData;

      menuAddOns = [variant, ...menuAddOns];
    }

    await dispatch(
      setSelectedItem({ ...selectedProduct, add_ons: menuAddOns }),
    );
    dispatch(setToggleItemDetails(true));
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page is navigated back to
  }, []);

  useEffect(() => {
    if (formCompleted) {
      setActiveKey([]);
    }
  }, [formCompleted]);

  // const getLocation = async () => {
  //   try {
  //     // Set loading to true immediately
  //     setLocationLoading(true);

  //     if (
  //       Object.values(orderFormData).length === 0 ||
  //       orderFormData?.fullName === undefined ||
  //       orderFormData?.contactNumber === undefined
  //     ) {
  //       // Ensure loading is set to false if validation fails
  //       setLocationLoading(false);
  //       alert("Kindly provide your full name and contact number first.");
  //       return;
  //     }

  //     // Check geolocation permission status
  //     const permissionStatus = await navigator.permissions.query({
  //       name: "geolocation",
  //     });

  //     if (permissionStatus.state === "denied") {
  //       setLocationLoading(false);
  //       alert(
  //         "Location access is denied. Please enable location permissions in your browser settings to proceed."
  //       );
  //       return;
  //     }

  //     if ("geolocation" in navigator) {
  //       navigator.geolocation.getCurrentPosition(
  //         async (position) => {
  //           try {
  //             const { latitude, longitude } = position.coords;

  //             const response = await axios.get(
  //               `https://nominatim.openstreetmap.org/reverse`,
  //               {
  //                 params: {
  //                   lat: latitude,
  //                   lon: longitude,
  //                   format: "json",
  //                 },
  //               }
  //             );

  //             const { data } = await axios.get(
  //               `https://api.dorydelivery.com/api/utility/get-province-city?latitude=${latitude}&longitude=${longitude}`
  //             );

  //             setCoordinates({ latitude, longitude });

  //             setValue("city", data.result.city);
  //             setValue("province", data.result.province);

  //             setValue("customerLatitude", latitude);
  //             setValue("customerLongitude", longitude);
  //             // setValue("city", data.result.city);
  //             // setValue("province", data.result.province);

  //             // setValue("city", "Roxas");
  //             // setValue("province", "Isabela");

  //             setValue("address", response.data.display_name);

  //             if (data.result.city && data.result.province) {
  //               handleFieldChange("province");
  //               handleFieldChange("city");
  //             }
  //           } catch (error) {
  //             console.log(">>>> error:", error);
  //           } finally {
  //             // Ensure loading is set to false after all operations
  //             setLocationLoading(false);
  //           }
  //         },
  //         (error) => {
  //           console.error("Error getting user location:", error.message);
  //           // Set loading to false on error
  //           setLocationLoading(false);
  //           if (error.code === 1) {
  //             alert(
  //               "Location access was denied. Please enable location permissions in your browser settings."
  //             );
  //           }
  //         },
  //         {
  //           enableHighAccuracy: true,
  //           timeout: 10000,
  //           maximumAge: 0,
  //         }
  //       );
  //     } else {
  //       alert("Geolocation is not available in this browser.");
  //       setfirst("error");
  //       console.error("Geolocation is not available in this browser.");
  //       // Set loading to false if geolocation is not available
  //       setLocationLoading(false);
  //     }
  //   } catch (error) {
  //     // Set loading to false on any unexpected errors
  //     setLocationLoading(false);
  //     console.error(
  //       "Error checking permissions or getting location:",
  //       error.message
  //     );
  //   }
  // };

  // testing ================================================= to be remove

  const openInExternalBrowser = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const url = window.location.href;

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      window.open(url, "_blank");
    } else if (/android/i.test(userAgent)) {
      const intentUrl = `intent://${url.replace(
        /^https?:\/\//,
        "",
      )}#Intent;scheme=https;end;`;

      window.location.href = intentUrl;
      navigate("/external-browser");
    }
  };

  const getLocation = async () => {
    dispatch(setTogglePabiliMap(true));

    // try {
    //   setLocationLoading(true);

    //   if (
    //     Object.values(orderFormData).length === 0 ||
    //     orderFormData?.fullName === undefined ||
    //     orderFormData?.contactNumber === undefined
    //   ) {
    //     // Ensure loading is set to false if validation fails
    //     setLocationLoading(false);
    //     alert("Kindly provide your full name and contact number first.");
    //     return;
    //   }

    //   if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(
    //       async (position) => {
    //         const { latitude, longitude } = position.coords;

    //         const response = await axios.get(
    //           `https://nominatim.openstreetmap.org/reverse`,
    //           {
    //             params: { lat: latitude, lon: longitude, format: "json" },
    //           }
    //         );

    //         const { data } = await axios.get(
    //           `https://api.dorydelivery.com/api/utility/get-province-city?latitude=${latitude}&longitude=${longitude}`
    //         );

    //         setCoordinates({ latitude, longitude });
    //         // setValue("city", data.result.city);
    //         // setValue("province", data.result.province);
    //         setValue("city", "Roxas");
    //         setValue("province", "Isabela");
    //         setValue("customerLatitude", latitude);
    //         setValue("customerLongitude", longitude);
    //         setValue("address", response.data.display_name);

    //         if (data.result.city && data.result.province) {
    //           handleFieldChange("province");
    //           handleFieldChange("city");
    //         }
    //       },
    //       (error) => {
    //         console.error("Error getting location:", error);

    //         const userAgent =
    //           navigator.userAgent || navigator.vendor || window.opera;
    //         const isAndroid = /android/i.test(userAgent);

    //         if (isAndroid) {
    //           setModal(true);
    //           return;
    //         }

    //         setLocationLoading(false);

    //         alert(
    //           "Unable to fetch location. Please ensure location permissions are enabled."
    //         );
    //         // openInExternalBrowser();
    //       },
    //       {
    //         enableHighAccuracy: true,
    //         timeout: 10000,
    //         maximumAge: 0,
    //       }
    //     );
    //   } else {
    //     alert("Geolocation is not available in this browser.");
    //     setLocationLoading(false);
    //   }
    //   // }
    // } catch (error) {
    //   setLocationLoading(false);
    //   console.error("Error while getting location:", error.message);
    // }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "auto",
        backgroundColor: "#fff",
      }}
    >
      {contextHolder}
      <div>
        <div
          style={{
            marginLeft: 18,
            position: "relative",
            display: "inline-block",
          }}
        >
          <Title
            level={2}
            style={{
              position: "relative",
              zIndex: 1,
              marginBottom: 0,
            }}
          >
            {greeting}
          </Title>

          {/* <div
            style={{
              position: "absolute",
              bottom: 0,
              height: 12,
              backgroundColor: "#00f57f",
              width: "100%",
              zIndex: 0,
            }}
          /> */}
        </div>
      </div>
      <div style={{ marginBottom: 16 }}>
        <Text
          style={{
            fontWeight: "bold",
            color: "#00f57f",
            fontSize: 24,
            marginLeft: 16,
            marginBottom: 16,
          }}
        >
          {`Let’s satisfy your cravings 🍕`}
        </Text>
      </div>
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <Space size="middle" direction="vertical" style={{ display: "flex" }}>
          <Collapse
            activeKey={activeKey}
            onChange={handleCollapseChange}
            accordion={true}
            size="large"
            bordered={false}
            style={{
              backgroundColor: "#fff",
              margin: 16,
              boxShadow: "0px 6px 18px rgba(59, 59, 59, 0.1)",
              borderRadius: 16,
            }}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined
                tyle={{ fontSize: "24px" }}
                rotate={isActive ? 90 : 0}
              />
            )}
          >
            <Panel header="Customer details" key="1">
              <div style={{ marginBottom: 0 }}>
                <Controller
                  control={control}
                  name="fullName"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Form.Item
                      label={
                        <label
                          htmlFor={"fullName"}
                          style={{ fontWeight: "bold", fontSize: 18 }}
                        >
                          Full name
                        </label>
                      }
                      required={true}
                      style={{ marginBottom: 0 }}
                    >
                      <Input
                        allowClear
                        onChange={(e) => {
                          onChange(e);
                          handleFieldChange("fullName");
                        }}
                        value={value}
                        size="large"
                      />
                    </Form.Item>
                  )}
                />
                {errors.fullName && (
                  <Text type="danger">{errors.fullName.message}</Text>
                )}
              </div>
              <div style={{ marginBottom: 12 }}>
                <Controller
                  control={control}
                  name="contactNumber"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Form.Item
                      label={
                        <label
                          htmlFor={"contactNumber"}
                          style={{ fontWeight: "bold", fontSize: 18 }}
                        >
                          Contact number
                        </label>
                      }
                      required={true}
                      style={{ marginBottom: 0 }}
                    >
                      <Input
                        placeholder="ex. 09123456789"
                        allowClear
                        onChange={(e) => {
                          onChange(e);
                          handleFieldChange("contactNumber");
                        }}
                        value={value}
                        size="large"
                      />
                    </Form.Item>
                  )}
                />
                {errors.contactNumber && (
                  <Text type="danger">{errors.contactNumber.message}</Text>
                )}
              </div>

              <div>
                {address ? (
                  <>
                    <Controller
                      control={control}
                      name="address"
                      render={({ field: { onChange, onBlur, value } }) => (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-end",
                            gap: "8px",
                          }}
                        >
                          {/* Input Field */}
                          <Form.Item
                            label={
                              <label
                                htmlFor={"address"}
                                style={{ fontWeight: "bold", fontSize: 18 }}
                              >
                                Delivery location
                              </label>
                            }
                            required={true}
                            style={{ marginBottom: 0, flex: 1 }}
                          >
                            <Input
                              allowClear
                              onChange={(e) => {
                                onChange(e);
                                handleFieldChange("address");
                              }}
                              value={value}
                              size="large"
                              disabled
                            />
                          </Form.Item>
                        </div>
                      )}
                    />
                  </>
                ) : (
                  <div
                    style={{
                      marginTop: 22,
                    }}
                  >
                    <label style={{ fontWeight: "bold", fontSize: 18 }}>
                      Delivery location
                    </label>
                    <br />
                    <label style={{ fontSize: 12 }}>
                      We'll use your current location as your delivery address.
                    </label>
                    <Button
                      type="primary"
                      icon={<EnvironmentOutlined />}
                      onClick={getLocation}
                      disabled={locationLoading}
                      loading={locationLoading}
                      size="large"
                      style={{ width: "100%", marginTop: 12, height: 62 }}
                      color="default"
                      variant="solid"
                    >
                      {locationLoading
                        ? "Getting your current location..."
                        : "Pin Location"}
                    </Button>
                  </div>
                )}

                {errors.address && (
                  <Text type="danger">{errors.address.message}</Text>
                )}
              </div>
            </Panel>
          </Collapse>
          {/*  */}
        </Space>

        <div style={{ marginLeft: 16, marginRight: 16, marginTop: 12 }}>
          {formCompleted && (
            <div>
              <div
                style={{
                  flex: 1,
                  justifyContent: "space-between",
                  marginBottom: 8,
                }}
              >
                {/* <Text
                  style={{ fontWeight: "bold", color: "#00BF63", fontSize: 16 }}
                >
                  {` ${cityContainer}, ${provinceContainer}`}
                </Text> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    cursor: "pointer",
                  }}
                  onClick={getLocation}
                >
                  <FaLocationDot size={16} style={{ color: "#00BF63" }} />
                  <Text
                    style={{
                      fontWeight: "bold",
                      color: "#00BF63",
                      fontSize: 16,
                    }}
                  >
                    {` ${cityContainer}, ${provinceContainer}`}
                  </Text>
                  <EditOutlined style={{ color: "#00BF63", fontSize: 16 }} />
                </div>
              </div>

              <Controller
                control={control}
                name="merchant"
                render={({ field: { onChange, onBlur, value } }) => (
                  <Form.Item
                    label={
                      <label
                        htmlFor={"merchant"}
                        style={{ fontWeight: "bold", fontSize: 18 }}
                      >
                        Select a merchant around your area
                      </label>
                    }
                    required={true}
                    style={{ marginBottom: 0 }}
                  >
                    {loading ? (
                      <Skeleton.Input block active />
                    ) : (
                      <Select
                        value={value}
                        showSearch
                        placeholder="Select Merchant"
                        optionFilterProp="label"
                        onChange={(e) => {
                          onChange(e);
                          handleFieldChange("merchant");
                        }}
                        // onDropdownVisibleChange={handleDropdownVisibility}
                        options={merchantsInArea}
                      />
                    )}
                    {/* <Button
                      type="primary"
                      size="large"
                      color="default"
                      variant="solid"
                      style={{
                        width: "100%",
                        height: "45px",
                        marginBottom: 10,
                      }}
                      onClick={() => showDrawer()}
                    >
                      {selectedMerchantValue !== null ? (
                        selectedMerchantValue === "Others" ? (
                          <div style={{ fontSize: 12, fontWeight: "bold" }}>
                            {" "}
                            {pabiliDetails?.pickupLocation?.locationText}
                          </div>
                        ) : (
                          <Text
                            style={{
                              color: "#fff",
                              fontWeight: "bold",
                              fontSize: 18,
                            }}
                          >{`${selectedMerchantValue}`}</Text>
                        )
                      ) : (
                        "Select Merchant"
                      )}
                    </Button> */}
                  </Form.Item>
                )}
              />
              {errors.merchant && (
                <Text type="danger">{errors.merchant.message}</Text>
              )}
            </div>
          )}

          <br />
          {selectedMerchant && !menuLoading && !categoryLoading && (
            <Search
              placeholder="Input search text"
              enterButton={
                <Button
                  type="primary"
                  style={{ backgroundColor: "black", borderColor: "black" }}
                >
                  Search
                </Button>
              }
              size="large"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onSearch={(value) => {
                if (value.trim() === ",") return;

                const newPattern = value
                  .split(",")
                  .map((item) => item.trim())
                  .filter((item) => item !== "");

                setSearchPattern(newPattern);
                setInputValue(value);
              }}
            />
          )}

          {selectedMerchant !== 1 && selectedMerchant !== "" ? (
            <Title level={5}>Available Menus:</Title>
          ) : (
            <></>
          )}
          {categoryLoading ? (
            <Skeleton.Input block active />
          ) : selectedMerchant === 1 ? null : (
            <DynamicCategoryTabs
              key={selectedMerchant}
              categories={merchantCategories}
              merchantId={selectedMerchant}
              onClickProduct={onClickProduct}
              searchPattern={searchPattern}
            />
          )}
        </div>

        {isPabiliDetailsValid ? (
          <div style={{ padding: "16px", marginTop: -30 }}>
            <br />
            <TextArea
              onChange={handleNoteChange}
              value={note}
              rows={6}
              placeholder={`Store name: \nItem 1 name, Quantity \nItem 2 name, Quantity \n \n-- Additional instructions --`}
            />
          </div>
        ) : null}

        {orderItems.length !== 0 || isPabiliDetailsValid ? (
          <Button
            block={true}
            htmlType="submit"
            type="primary"
            size="large"
            style={{
              position: "fixed",
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1000,
              width: "90%",
              padding: 22,
              borderRadius: 12,
              fontWeight: "bold",
              background: "#00BF63",
            }}
            disabled={isPabiliDetailsValid && note === ""}
          >
            Checkout
          </Button>
        ) : null}
      </Form>
      <ItemDetails triggerMessage={successMessage} />
      <ReviewOrder toggleReviewOrder={toggleReviewOrder} />
      <PabiliMap
        setValue={setValue}
        handleFieldChange={handleFieldChange}
        setCoordinates={setCoordinates}
      />
      <RedirectModal
        open={modal}
        setOpen={setModal}
        handleOk={openInExternalBrowser}
      />
      {/* <Drawer
        title="Select a merchant"
        placement={"bottom"}
        closable={false}
        onClose={() => setBottomDrawer(false)}
        open={bottomDrawer}
        key={"bottom"}
        height={502}
      >
        <div style={{ marginTop: -20 }}>
          {merchantsInArea.map((merchant) => (
            <div
              style={{
                maxHeight: "80vh",
                overflowY: "auto", // Enable vertical scrolling
              }}
            >
              <div
                style={{
                  marginBottom: 15,
                  height: "65px",
                  borderRadius: 22,
                  alignItems: "center",
                  display: "flex",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#fff",
                  padding: 8,
                }}
                onClick={() => {
                  setValue("merchant", merchant.value);
                  setBottomDrawer(false);
                  setSelectedMerchantValue(merchant.label);
                }}
              >
                {merchant.image !== undefined ? (
                  <Image
                    width={65}
                    height={65}
                    preview={false}
                    src={`https://groceria-storage.sgp1.cdn.digitaloceanspaces.com/assets/images/merchants/${merchant.image}`}
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = merchatOtherLogo; // Fallback to placeholder
                    }}
                    style={{
                      borderRadius: 100,
                      padding: 10,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      backgroundColor: "#E5E7EB",
                      borderRadius: 100,
                      marginLeft: 8,
                    }}
                  >
                    <IoStorefrontSharp
                      size={24}
                      color="#9CA3AF"
                      style={{ padding: 10 }}
                    />
                  </div>
                )}
                <div
                  style={{ marginLeft: 10, fontSize: 16, fontWeight: "bold" }}
                >
                  {merchant.label}
                </div>
              </div>
            </div>
          ))}
          {merchantsInArea.length === 1 && (
            <div style={{ fontSize: 15, marginTop: 25 }}>
              No merchant detected please click others to find a merchant
              location using the map.
            </div>
          )}
        </div>
      </Drawer> */}
    </div>
  );
};

export default OrderFormPage;
